__webpack_require__.p = "/ati-card-task/";